import * as CryptoJS from 'crypto-js';

export function isValidTemporaryLink(
  listingId: unknown,
  slug: unknown,
  tempHash: string | null
): boolean {
  const id = Number(listingId);

  if (
    !tempHash ||
    !Number.isSafeInteger(id) ||
    id <= 0 ||
    typeof slug !== 'string' ||
    !slug
  ) {
    return false;
  }

  // Keep the existing format used by the admin's Temporary Link action.
  const expectedHash = CryptoJS.MD5(JSON.stringify({id, name: slug})).toString();
  return tempHash === expectedHash;
}
